<div
  class="horizontalMenucontainer"
  [ngClass]="{ 'content-bg-primary': mode == 'dark' }"
>
  <div class="page">
    <div class="page-main">
      <!-- // header -->
      <app-header [isDarkMode]="mode == 'dark'"></app-header>
      <!-- //sidebar -->
      <app-sidebar appHoverEffectSidebar></app-sidebar>
      <div class="jumps-prevent" style="padding-top: 74px"></div>
      <div
        class="app-content main-content"
        [ngClass]="{ 'app-content-bg-primary': mode == 'dark' }"
      >
        <!-- <app-loader></app-loader> -->
        <div [ngClass]="{ 'pt-60': scrolled, 'side-app': mode != 'dark' }">
          <div
            class="main-container"
            [ngClass]="{ 'container-fluid': mode == 'dark' }"
            id="custom-main-container"
          >
            <!-- // contetnt  -->
            <router-outlet>
              <app-loader></app-loader>
            </router-outlet>
          </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
  <app-tab-to-top></app-tab-to-top>
</div>
